import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import SlideSection from 'components/SlideSection';
import GenreCard from 'components/cards/GenreCard';

import { concertsGenresTypes } from 'utils/helpers/genresCatalog';
import { screenBreakpoints } from 'utils/helpers/constants';

const ConcertRubricsCatalog = ({ rubrics }) => {
	const rubricData = _(concertsGenresTypes).reduce((memo, rubricType) => {
		const data = rubrics.find((rubric) => rubric.path === rubricType.path);

		return data ? memo.concat({ ...rubricType, ...data }) : memo;
	}, []);

	const sliderParams = {
		spaceBetween: 12,
		breakpoints: {
			[`${screenBreakpoints.notebook}`]: {
				spaceBetween: 14
			}
		}
	};

	const themes = ['primary', 'secondary', 'tertiary', 'quaternary'];

	return (
		!_.isEmpty(rubricData) && (
			<SlideSection
				title="Каталог"
				sliderParams={sliderParams}
				items={rubricData}
			>
				{_(rubricData).map((entity, index) => (
					<GenreCard
						key={entity._id}
						url={`/${entity.path}`}
						{...entity}
						theme={themes[index % 4]}
					/>
				))}
			</SlideSection>
		)
	);
};

ConcertRubricsCatalog.propTypes = {
	rubrics: PropTypes.array.isRequired
};

export default ConcertRubricsCatalog;
